import { render, staticRenderFns } from "./LivePortalHandoff.vue?vue&type=template&id=3cab2a5d"
import script from "./LivePortalHandoff.vue?vue&type=script&lang=js"
export * from "./LivePortalHandoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports